/**
 * Fetches all teams that have squad data from the backend.
 * Team list comes from GET /teams (squads in DB), so it works with any data source (e.g. football-data.org).
 */
const fetchAllTeams = async () => {
  const response = await fetch('/teams');
  if (!response.ok) {
    throw new Error(`Failed to fetch teams: ${response.statusText}`);
  }
  const teams = await response.json();
  return teams;
};

export default fetchAllTeams;
